module.exports = "/img/twitter_icon.svg?e34744f22e591484f81ab7f4577a15af";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/twitter_icon.svg
// module id = ogAf
// module chunks = 75